import { render, staticRenderFns } from "./EncodeSmallCard.vue?vue&type=template&id=98518bc4&scoped=true&"
import script from "./EncodeSmallCard.vue?vue&type=script&lang=ts&"
export * from "./EncodeSmallCard.vue?vue&type=script&lang=ts&"
import style0 from "./EncodeSmallCard.vue?vue&type=style&index=0&id=98518bc4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98518bc4",
  null
  
)

export default component.exports